module.exports = __webpack_public_path__ + "img/ring_r_o_1_1@3x.59068bf8.png";